import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./Carousel.css";

const pairs = [
  { before: "/Before1.JPG", after: "/After1.JPG" },
  { before: "/Before2.jpg", after: "/After2.jpg" },
  { before: "/Before3.JPG", after: "/After3.JPG" },
];

const SwiperComponentBA = () => (
  <Swiper
    className="carousel"
    modules={[Navigation, Pagination]}
    navigation
    pagination={{ clickable: true }}
    spaceBetween={24}
    slidesPerView={1}
  >
    {pairs.map((pair, index) => (
      <SwiperSlide key={pair.before}>
        <div className="ba-pair">
          <figure className="ba-photo">
            <img src={pair.before} alt={`Job ${index + 1} before`} loading="lazy" />
            <figcaption className="ba-badge ba-before">Before</figcaption>
          </figure>
          <figure className="ba-photo">
            <img src={pair.after} alt={`Job ${index + 1} after`} loading="lazy" />
            <figcaption className="ba-badge ba-after">After</figcaption>
          </figure>
        </div>
      </SwiperSlide>
    ))}
  </Swiper>
);

export default SwiperComponentBA;
